export default __webpack_public_path__ + "static/hero_community-e3ba882a60d685b9d00bd736626f903a.jpg";